<template>
  <div class="container">
    <section class="charge-lydia box">
      <h3>현재 <span style="color: red;">{{ currentLydia }}</span>LYD 보유중입니다.</h3>
      <h3>Lydia 충전</h3>
      <div class="charge-options-column">
        <label
          v-for="option in chargeOptions"
          :key="option.amount"
          class="radio-label"
        >
          <input
            type="radio"
            :value="option.amount"
            v-model="selectedChargeAmount"
            class="radio-input"
          />
          {{ option.text }}
        </label>
      </div>

      <div class="message-area">
        <p v-if="paymentError" class="error-message">
          결제 금액을 선택해주세요.
        </p>
        <p v-else-if="statusMessage" :class="['status-message', statusType]">
          {{ statusMessage }}
        </p>
      </div>

      <div class="button-group">
        <button @click="chargeLydia" class="charge-button">충전하기</button>
        <button @click="goBack" class="back-button">돌아가기</button>
      </div>
    </section>
    <section class="other-charge-methods box">
      <h3>다른 충전 수단</h3>
      <ul class="charge-method-list">
        <li>
          ✅ 출석 시
          <strong>매일 1회 50LYD</strong>
          가 자동 충전됩니다.
        </li>
        <li>
          📝 게시판 글쓰기 또는 댓글 작성 시
          <strong>1회당 50LYD</strong>
          ,
          <strong>하루 최대 3회</strong>
          까지 충전됩니다.
          <button class="menu-button" @click="goToBoard">
            게시판 바로가기
          </button>
        </li>
        <li>
          🔄 친구에게 링크를 공유하면
          <strong>100LYD</strong>
          충전,
          <strong>그 친구가 접속하면 추가 200LYD</strong>
          가 충전됩니다.
          <button class="menu-button" @click="shareLink">공유하기</button>
        </li>
        <!--li>
          🌐 외부 커뮤니티에 소개 글과 링크를 남기면 <strong>100 LYD</strong> 지급, 그 링크로 신규 사용자 유입 시 <strong>추가 100 LYD</strong>가 지급됩니다.
          <button @click="copyRefLink">링크 복사</button>
        </li-->
      </ul>
    </section>
  </div>
  <div v-if="isLoading" class="loading-overlay">
    <div class="spinner"></div>
  </div>
  <ChargeResultModal
    v-model:isVisible="isChargeResultModalVisible"
    :message="chargeResultModalMessage"
  />
</template>

<script setup>
  import Bootpay from '@bootpay/client-js'
  import { ref, onMounted, computed, watch, inject } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import { useStore } from 'vuex'
  import ChargeResultModal from '@/components/ChargeResultModal.vue'
  import { rewardUser } from '@/utils/setReward.js'
  import { doc, setDoc } from 'firebase/firestore' // Firestore 문서 업데이트 함수
  import { db } from '@/firebase' // Firestore 인스턴스 import
  import { generateCode } from '@/utils/utils'

  const showToast = inject('showToast')

  const router = useRouter()
  const route = useRoute()
  const store = useStore()
  const selectedChargeAmount = ref(null)
  const paymentError = ref(false)
  const isChargeResultModalVisible = ref(false)
  const chargeResultModalMessage = ref('')
  const statusMessage = ref('')
  const statusType = ref('')
  const user = computed(() => store.getters.getUser)
  const isLoading = ref(false)

  const chargeOptions = [
    { amount: 1000, charged: 1000, text: '1,000원 (1,000LYD)' },
    { amount: 3000, charged: 3100, text: '3,000원 (3,100LYD)' },
    { amount: 5000, charged: 5500, text: '5,000원 (5,500LYD)' },
    { amount: 10000, charged: 11500, text: '10,000원 (11,500LYD)' },
    { amount: 50000, charged: 60000, text: '50,000원 (60,000LYD)' },
  ]

  const currentLydia = computed(() =>
    store.getters.getLydia
      .toLocaleString('ko-KR', {
        style: 'currency',
        currency: 'KRW',
      })
      .replace('₩', ''),
  )

  watch(selectedChargeAmount, (val) => {
    if (val) paymentError.value = false
  })

  watch(isChargeResultModalVisible, (newVal, oldVal) => {
    if (oldVal && !newVal) {
      router.go(-2) // 모달이 닫히면 중간에 뜨는 ui.teledit.com(양식 다시 제출) 페이지 건너 뛰고 IChingDaily로 이동
    }
  })

  /*
const handleCloseChargeResultModal = () => {
  isChargeResultModalVisible.value = false;
  router.go(-1);
}
*/

  const goBack = () => {
    router.go(-1)
  }

  const goToBoard = () => {
    router.push('/board')
  }

  const refLink = computed(() => {
    const user = store.getters.getUser
    if (user)
      console.log('공유링크: ', `${location.origin}?ref=${user.accessToken}`)
    return user ? `${location.origin}?ref=${user.accessToken}` : ''
  })

  const shareLink = async () => {
    const user = store.getters.getUser
    if (!user) return

    const url = `${location.origin}?ref=${user.accessToken}`
    try {
      ;(await navigator.share)
        ? await navigator.share({
            title: '인생의 역점',
            text: '궁금하면 하늘에 답을 구하세요!',
            url,
          })
        : await navigator.clipboard.writeText(url) // fallback

      await rewardUser(store, 'share', { target: 'friend', url }, showToast)
      //alert('공유 보상이 지급되었습니다!');
    } catch (e) {
      console.error('공유 실패:', e)
    }
  }

  // 링크 게재된 URL 확인 등 관리 요소가 너무 많아서 일단은 보상 시스템에서 제외
  /*
const copyRefLink = async () => {
  const user = store.getters.getUser;
  if (!user) return;

  const url = `${location.origin}?ref=${user.accessToken}`;
  try {
    await navigator.clipboard.writeText(url);
    await rewardUser(store, 'writeShare', { target: 'community', url }, showToast);
    //alert('링크가 복사되었고, 보상이 지급되었습니다!');
  } catch (e) {
    console.error('링크 복사 실패:', e);
}}
*/

  const displayStatusMessage = (message, type) => {
    statusMessage.value = message
    statusType.value = type
    setTimeout(() => (statusMessage.value = ''), 2000)
  }

  const showChargeResultModal = async (message) => {
    let finalMessage = message
    const user = store.getters.getUser

    if (!user.recoveryCode) {
      // 복구 코드가 없는 경우 새로 생성
      const recoveryCode = generateCode(10)
      await setDoc(
        doc(db, 'users', user.accessToken),
        { recoveryCode },
        { merge: true },
      )

      finalMessage += `<br><br>아래 복구 코드를 반드시 기록해두세요.<br>계정 복구 시 필요합니다.<br>
    <span class="highlight-code">${recoveryCode}</span>`
    }

    chargeResultModalMessage.value = finalMessage
    isChargeResultModalVisible.value = true
  }

  // 결제 요청
  const chargeLydia = async () => {
    if (!selectedChargeAmount.value) {
      paymentError.value = true
      return
    }

    const selectedOption = chargeOptions.find(
      (o) => o.amount === selectedChargeAmount.value,
    )
    const productName = selectedOption?.text ?? '리디아 충전'

    try {
      const redirectUrl = new URL('https://lydiatree.kr/ChargeLydia')
      const params = {
        accessToken: user.value.accessToken,
        amount: selectedChargeAmount.value,
      }
      redirectUrl.searchParams.set(
        'payload',
        encodeURIComponent(JSON.stringify(params)),
      )

      console.log('리디렉션 URL:', redirectUrl.toString())

      await Bootpay.requestPayment({
        application_id: import.meta.env.VITE_BOOTPAY_APPLICATION_ID,
        price: selectedChargeAmount.value,
        order_name: productName,
        order_id: `order_${Date.now()}`,
        user_info: {
          id: user.value?.accessToken,
          username: user.value?.name,
          email: user.value?.email,
        },
        extra: {
          redirect_url: redirectUrl.toString(),
        },
      })
    } catch (error) {
      console.error('Bootpay 요청 오류:', error)
      displayStatusMessage(error.message, 'error')
    }
  }

  // 리디렉션 후 URL 파라미터로 결제 결과 처리
  onMounted(async () => {
    const status = route.query.status
    console.log('Redirected URL: ', route.query)
    // https://lydiatree.kr/ChargeLydia?accessToken=KhSJ2UTVOCJjZhG2wx7QDPv62R8d8r&amount=1000&event=done&order_id=order_1747811223606&receipt_id=682d7b971fee2c462f1ee132&status=1&status_locale=%EA%B2%B0%EC%A0%9C%EC%99%84%EB%A3%8C

    // route.query에 status 항목이 없으면 일반 메뉴 이동이다. 이 경우 아래 결제 후 후속처리는 건너 뛴다.
    if (!status) return

    const event = route.query.event
    const receiptId = route.query.receipt_id

    const rawPayload = route.query.payload
    let payload = {}
    try {
      payload = JSON.parse(decodeURIComponent(rawPayload))
    } catch (error) {
      console.error('Payload 파싱 오류:', error)
    }
    const payloadAccessToken = payload.accessToken
    const amount = payload.amount
    if (!payloadAccessToken || !amount) {
      console.error(
        '콜백 Payload 오류입니다. accessToken 또는 amount가 없습니다.',
        payload,
      )
      displayStatusMessage('잘못된 콜백 Payload입니다.', 'error')
      return
    }

    console.log(
      'accessToken:',
      payloadAccessToken,
      ', user accessToken:',
      user.value?.accessToken,
    )
    if (user.value?.accessToken !== payloadAccessToken) {
      console.error(
        '사용자 accessToken이 일치하지 않습니다.',
        user.value?.accessToken,
        accessToken,
      )
      displayStatusMessage('사용자 인증 오류입니다.', 'error')
      return
    }

    const selectedOption = chargeOptions.find((o) => o.amount == amount)

    const chargeInfo = {
      ...Object.fromEntries(Object.entries(route.query)),
    }

    if (status === '1' && receiptId) {
      // 결제 성공 후 화면 refresh에 의한 Lydia 중복 충전을 방지하기 위해
      const lastId = localStorage.getItem('lastReceiptId')
      if (lastId === receiptId) {
        return
      }

      isLoading.value = true
      try {
        const result = await store.dispatch('chargeLydia', {
          userName: user.value?.name,
          accessToken: payloadAccessToken,
          amount: selectedOption.charged,
          chargeInfo,
        })

        if (result.success) {
          localStorage.setItem('lastReceiptId', receiptId)
          showChargeResultModal(result.message)
        } else {
          displayStatusMessage(result.message, 'error')
        }
      } catch (error) {
        console.error('충전 처리 오류:', error)
        displayStatusMessage('충전 중 문제가 발생했습니다.', 'error')
      } finally {
        isLoading.value = false
      }
    } else if (status === '0' || event === 'error') {
      const message = '결제에 실패했습니다: ' + route.query.status_locale
      displayStatusMessage(message, 'error')
    }
  })
</script>

<style>
  .container {
    width: var(--device-width);
    max-width: 480px;
    margin: 40px auto;
    padding: 20px;
  }

  h3 {
    text-align: center;
    margin-bottom: 20px;
  }

  .box {
    background-color: var(--color-background);
    border: 1px solid #ccc; /* Gray border */
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 30px; /* Spacing between boxes */
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  .charge-options-column {
    display: flex;
    flex-direction: column; /* Arrange radio buttons in a column */
    align-items: flex-start; /* Left align radio buttons */
    gap: 10px; /* Space between radio buttons */
    margin-bottom: 20px;
  }

  .charge-options {
    margin-bottom: 25px; /* Space between radio buttons and button */
  }

  .radio-label input[type='radio'] {
    margin-right: 5px;
    vertical-align: middle;
  }

  ul {
    margin: 0 0.5rem;
    padding: 0 0.5rem;
  }

  .menu-button {
    font-size: var(--font-size-095);
  }

  .charge-button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    background-color: #4caf50;
    color: white;
    cursor: pointer;
    margin: 0 5px; /* Space between buttons */
  }

  .charge-button:hover {
    background-color: #45a049;
  }

  .button-group {
    display: flex;
    justify-content: center; /* Center the button group */
    gap: 10px; /* Space between buttons */
  }

  .back-button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    cursor: pointer;
  }

  .message-area {
    height: 40px; /* 항상 공간 확보 */
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: 10px;
    overflow-x: hidden; /* 내용이 넘칠 경우 숨김 처리 */
  }

  .message-area p {
    margin: 0;
    padding: 0;
    line-height: 1.2;
  }

  .error-message {
    color: red;
    font-size: var(--font-size-095);
  }

  .status-message {
    font-size: var(--font-size-095);
    padding: 0.4rem 1rem;
    border-radius: 4px;
    text-align: center;
  }

  .status-message.success {
    color: #45a049;
    font-size: var(--font-size-095);
  }

  .status-message.error {
    color: red;
    font-size: var(--font-size-095);
  }

  /* Custom styles for back button color */
  .back-button {
    background-color: #f44336; /* Red */
    color: white;
  }
  .back-button:hover {
    background-color: #da190b; /* Darker red */
  }

  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: var(--device-width);
    max-width: 480px; /* 최대 너비 설정 */
    margin: auto;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* 다른 요소 위에 표시 */
  }

  .spinner {
    border: 6px solid #ccc;
    border-top: 6px solid #4caf50;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
